// extracted by mini-css-extract-plugin
export default {"input-radio-wrap":"radioButton_input-radio-wrap__mcp8m","input-radio":"radioButton_input-radio__YkNvT"};